import React from 'react';
import PropTypes from 'prop-types';
import styled, { createGlobalStyle } from 'styled-components';
import { withSiteData } from 'react-static';
import { media } from '../../../styles/style-utils';

import Section from '../../common/Section';
import Anchor from '../utils/Anchor';
import appStoreBadge from '../../../assets/images/badges/app-store-iphone.png';
import googlePlayBadge from '../../../assets/images/badges/google-play.svg';
import idagioDownloadBadge from '../../../assets/images/badges/idagio-download.svg';

const Wrapper = styled(Section)`
  padding: var(--default-vertical-padding) var(--default-horizontal-padding);
  padding-top: 0;
`;

const HorizontalLine = styled.div`
  border-bottom: calc(var(--fr) * 0.0625) solid var(--c-gray);
`;

const GlobalStyle = createGlobalStyle`
  :root {
    --badgeListH: 50px;
    --badgeListP: .5rem;
    --badgeListM: 10px;

    ${media.small`
      --badgeListH: 60px;
    `};
  }
`;

const BadgeList = styled.ul`
  text-align: center;
  display: inline-block;

  ${media.mediumLarge`
    display: inline-flex;
  `}
`;

const BadgeListItem = styled.li`
  align-items: center;
  height: var(--badgeListH);
  line-height: 0;
  margin: calc(var(--badgeListM) * 2);
  vertical-align: middle;

  ${media.mediumLarge`
    margin: var(--badgeListM) calc(var(--badgeListM) * 2);
  `}
`;

const BadgeLink = styled.a`
  display: block;
`;

const BadgeImage = styled.img`
  height: var(--badgeListH);
  width: auto;
`;

const BadgesSection = ({ appDomain }) => {
  const badges = [
    {
      file: <BadgeImage src={appStoreBadge} alt="" />,
      link: 'https://itunes.apple.com/app/idagio/id1014917700?mt=8',
      ariaLabelText: 'Apple App Store',
    },
    {
      file: <BadgeImage src={googlePlayBadge} alt="" />,
      link: 'https://play.google.com/store/apps/details?id=com.idagio.app',
      ariaLabelText: 'Google Play Store',
    },
    {
      file: <BadgeImage src={idagioDownloadBadge} alt="" />,
      link: `${appDomain}/download`,
      ariaLabelText: 'IDAGIO download desktop',
    },
  ];

  return (
    <React.Fragment>
      <Anchor id="badges-section" />
      <Wrapper textAlign="center">
        <BadgeList>
          <GlobalStyle />
          {badges.map(({ file, link, ariaLabelText }, i) => (
            <BadgeListItem key={i}>
              <BadgeLink href={link} aria-label={ariaLabelText} target="_blank">
                {file}
              </BadgeLink>
            </BadgeListItem>
          ))}
        </BadgeList>
      </Wrapper>
      <HorizontalLine />
    </React.Fragment>
  );
};

BadgesSection.propTypes = {
  appDomain: PropTypes.string.isRequired,
};

export default withSiteData(BadgesSection);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/badges/BadgesSection.js